import 'intersection-observer';

import { ResizeObserver } from '@juggle/resize-observer';
import smoothscroll from 'smoothscroll-polyfill';

if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'undefined') {
  window.ResizeObserver = ResizeObserver;
}

smoothscroll.polyfill();
